import { type OmitPageParam, usePagination } from '@/composables/usePagination'
import { getComplaintSearchApi } from '@/server'
import type { ComplaintSearchParams, ComplaintSearchResponse } from '@/server/types'

export function logicComplaintSearch() {
  const data = ref<ComplaintSearchResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '投诉搜索',
    pageSize: 20,
    request: (page, params: OmitPageParam<ComplaintSearchParams> = {}) => getComplaintSearchApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: OmitPageParam<ComplaintSearchParams> = {}) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    if (p === 1)
      data.value = []

    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}
